import root from 'window-or-global';


class IndexedDbWrapper {
  idbObject = null;
  jobsDbName = 'quikr-pwa-jobs';
  jobsApplyTable = "jobs-applied-offline";
  jobsDbVersion = null;

  // keys to store indexeddb versions in local storage
  jobsIndexedDbLSKey = 'jobsIndexedDbVersionPWA';
  jobsIndexedDbGlobalLSKey = 'jobsGlobalIndexedDbVersionPWA';

  constructor () {
    const self = this;

    const _initDb = function (dbVersion) {
      dbVersion = dbVersion ? dbVersion : 1;

      const request = root.indexedDB.open(self.jobsDbName);
      request.onsuccess = function (event) {
        self.idbObject = event.target.result;
        afterIdbInit();
      };

      request.onupgradeneeded = function (event) {
        self.idbObject = event.target.result;

        if (!self.idbObject.objectStoreNames.contains(self.jobsApplyTable)) {
          const objectStore = self.idbObject.createObjectStore(self.jobsApplyTable, {
            keyPath: "id", autoIncrement: true
          });
        }
      };

      request.onerror = function (event) {
        console.log("indexeddb open error: ", event);
        self.sendSentryError("Error occurred while creating indexeddb.\nMessage : " + JSON.stringify(event));
        // since indexeddb.open failed for a specific version, we try to upgrade indexeddb version
        // _initDb(dbVersion + 1);
      };
    };

    const afterIdbInit = function () {
      self.jobsDbVersion = self.idbObject.version;

      if (self.idbObject.objectStoreNames.contains(self.jobsApplyTable)) {
        const applyDbStore = self.idbObject.transaction([self.jobsApplyTable], "readwrite")
          .objectStore(self.jobsApplyTable);
      } else {
        // since objectstore for apply table isnt there, we try to upgrade indexeddb version
        // _initDb(self.jobsDbVersion + 1);
      }
    };

    if (root.indexedDB) {
      _initDb();
    }
  }

  dropIndexedDb = () => {
    if (root.indexedDB) {
      const request = root.indexedDB.deleteDatabase(this.jobsDbName);
      request.onsuccess = function (event) {
        // console.log("success: ", event);
      };

      request.onerror = function (event) {
        // console.log("error: ", event);
      };
    }
  };

  removeApplyFromIdb = (applyObj, type) => {
    // console.log('remove post idb', applyObj.id);
    if (this.idbObject && this.idbObject.objectStoreNames.contains(this.jobsApplyTable)) {
      const db = this.idbObject;
      const jobsApplyTable = this.jobsApplyTable;

      const applyDBStore = db.transaction([jobsApplyTable], "readwrite").objectStore(jobsApplyTable);
      const requestDelete = applyDBStore.delete(Number(applyObj.id));
      requestDelete.onsuccess = function(e) {
        // console.log('Record deleted successfully...', e);
      };
      requestDelete.onerror = function(e) {
        // console.log('Record could not be deleted...', e);
      };
    }
  };

  getIdbCursorRequest = () => {
    if (this.idbObject && this.idbObject.objectStoreNames.contains(this.jobsApplyTable)) {
      const db = this.idbObject;
      const jobsApplyTable = this.jobsApplyTable;

      const applyTransaction = db.transaction([jobsApplyTable], "readwrite");
      const applyDBStore = applyTransaction.objectStore(jobsApplyTable);

      const keyRange = IDBKeyRange.lowerBound(0);
      const cursorRequest = applyDBStore.openCursor(keyRange);
      return {applyTransaction, cursorRequest};
    } else {
      return {};
    }
  };

  getAppliedJobsByStatus = (status) => {
    const applyObjects = [];
    const {applyTransaction, cursorRequest} = this.getIdbCursorRequest();

    if (!cursorRequest) {return {};}
    cursorRequest.onsuccess = function(e) {
      const result = e.target.result;

      if (result) {
        // console.log('result', result.value);

        if (status) {
          if (result.value.applyStatus === status) {
            const applyObject = result.value;
            applyObjects.push(applyObject);
          }
        } else {
          const applyObject = result.value;
          applyObjects.push(applyObject);
        }

        result.continue();
      } else {
        // console.log("No more entries!");
      }
    };

    return {applyTransaction, applyObjects};
  };

  sendSentryError = (msg) => {
    if (typeof JobsSentry !== 'undefined') {
      JobsSentry.captureMessage(msg);
    }
  };

}

export default new IndexedDbWrapper();



// WEBPACK FOOTER //
// ../q-jobs/src/utils/IndexedDbWrapper/index.js